import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const IdleButtonsContext = createContext({ isIdleHidden: false, hideNow: () => {} });

const DEFAULT_IDLE_MS = 10000;
export const IDLE_BUTTONS_HIDE_NOW_EVENT = "lesson-launchpad:idle-buttons-hide-now";

export function IdleButtonsProvider({ children, idleMs = DEFAULT_IDLE_MS }) {
  const [isIdleHidden, setIsIdleHidden] = useState(false);
  const timeoutRef = useRef(null);

  const hideNow = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsIdleHidden(true);
  }, []);

  const resetIdleTimer = useCallback(() => {
    setIsIdleHidden(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setIsIdleHidden(true);
    }, idleMs);
  }, [idleMs]);

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "touchmove"];
    const options = { passive: true };

    resetIdleTimer();
    events.forEach((eventName) => window.addEventListener(eventName, resetIdleTimer, options));
    window.addEventListener(IDLE_BUTTONS_HIDE_NOW_EVENT, hideNow);

    return () => {
      events.forEach((eventName) => window.removeEventListener(eventName, resetIdleTimer, options));
      window.removeEventListener(IDLE_BUTTONS_HIDE_NOW_EVENT, hideNow);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [hideNow, resetIdleTimer]);

  return (
    <IdleButtonsContext.Provider value={{ isIdleHidden, hideNow }}>
      {children}
    </IdleButtonsContext.Provider>
  );
}

export function useIdleButtons() {
  return useContext(IdleButtonsContext);
}

